// @ts-nocheck
import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Form, Input, Button, Row, Col, Select, message, DatePicker } from 'antd';

//API
import { fetchMessageListAPI } from 'services/shared/fetchLovList';
import {
	fetchAccountingReports,
	fetchParams,
	fetchGeneratedReports,
	generateArPerClient,
	generateArSummary,
	generateBirSalesRep,
	generateColRepPerClient,
	generateColRepPerMonth,
	generateColRepPerWeek,
	generateColRepSummary,
	generateOrSeries,
	generateDrSeries,
	generateRepAgentPerMonth,
	generateSalesRepPerClientMonth,
	generateSalesRepPerMonthBr,
	generateSoa,
	generateSalesRepPerAgentMonth,
	generateColRepPerPayDate,
	generateArAging,
	generateAr,
	generateArAgingPerClient,
	generateColReport,
	generateSalesReport,
	generateUnbilledDr,
	generateDrClientDelivery
} from 'services/accounting_reports/accounting_reports';

import SearchLov from './getLov';
import SearchReportTable from './searchReportTable';

//USER DETAILS
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';

//MESSAGE PROMPTS
import Message from 'shared_components/message';

//OTHERS
import moment from 'moment';
import { set } from 'lodash';
const { Text } = Typography;
const { Option } = Select;

function SearchReportForm(props) {
    const [form] = Form.useForm();
	const { onFinish } = props;
	const navigate = useHistory();
	const formRef = useRef();
	const [loading, setLoading] = useState(false);
	const [reportType, setReportType] = useState();
	const [messagesList, setMessagesList] = useState([]);
	const [reportsList, setReportsList] = useState([]);
	const [params, setParams] = useState([]);
	const [customerLabel, setcustomerLabel] = useState([]);
	const [monthLabel, setmonthLabel] = useState();
	const [yearLabel, setyearLabel] = useState();
	const [dateLabel, setdateLabel] = useState();
	const [agentLabel, setagentLabel] = useState();
	const [weekLabel, setweekLabel] = useState();
	const [asOfDateLabel, setAsOfDateLabel] = useState();
	const [generatedReports, setGeneratedReports] = useState([]);
	const [latestGeneratedId, setLatestGeneratedId] = useState(null);
	const [disable, setDisable] = useState(true);
	const [getParamCustomer, setParamCustomer] = useState();
	const [getParamMonYear, setParamMonYear] = useState();
	const [getParamYear, setParamYear] = useState();
	const [getParamAgent, setParamAgent] = useState();
	const [getParamDate, setParamDate] = useState();
	const [getParamWeek, setParamWeek] = useState('');
	const [getParamGenerate, setParamGenerate] = useState([]);
	const [getParamAsOfDate, setParamAsOfDate] = useState();
	const userID = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA)).userID;

	useEffect(() => {
		async function fetchData() {
			const messages = await fetchMessageListAPI();
			const dropDownReports = await fetchAccountingReports();

			// Filter to show only DR reports (document_id: 25, 26, 27)
			const drReports = dropDownReports.filter(report =>
				[25, 26, 27].includes(report.document_id)
			);

			setMessagesList(messages);
			setReportsList(drReports);
		}
		setLoading(true);
		fetchData();
		setLoading(true);
	}, []);

	useEffect(() => {
		const getCustomerLabel = params.filter(items => items.parameter_label === 'CUSTOMER');
		const getYearLabel = params.filter(par => par.parameter_label === 'YEAR');
		const getMonthLabel = params.filter(par => par.parameter_label === 'MON-YEAR');
		const getDateLabel = params.filter(par => par.parameter_label === 'SOA DATE');
		const getAgentLabel = params.filter(par => par.parameter_label === 'AGENT');
		const getWeekLabel = params.filter(par => par.parameter_label === 'WEEK NO');
		const getAsOfDateLabel = params.filter(par => par.parameter_label === 'AS OF DATE');

		if (getCustomerLabel.length > 0) {
			setcustomerLabel(getCustomerLabel[0].parameter_label);
		}
		if (getYearLabel.length > 0) {
			setyearLabel(getYearLabel[0].parameter_label);
		}

		if (getMonthLabel.length > 0) {
			setmonthLabel(getMonthLabel[0].parameter_label);
		}

		if (getDateLabel.length > 0) {
			setdateLabel(getDateLabel[0].parameter_label);
		}

		if (getAgentLabel.length > 0) {
			setagentLabel(getAgentLabel[0].parameter_label);
		}

		if (getWeekLabel.length > 0) {
			setweekLabel(getWeekLabel[0].parameter_label);
		}

		if(getAsOfDateLabel.length > 0){
			setAsOfDateLabel(getAsOfDateLabel[0].parameter_label);
		}
	});

	// get reports list where module_code = 'DR'
	const reportsOptions = reportsList
	.filter(item => item.module_code === 'RPT_DR')
	.map((item, index) => (
		<Option key={index} value={item.document_id}>
		{item.document_name}
		</Option>
	));

	async function handleSubmit(formValues) {
		const currentDate = new Date()
		const formatMonth = (currentDate.getMonth()+1) < 10 ? '0'+(currentDate.getMonth()+1) : (currentDate.getMonth()+1)
		const formatDate = currentDate.getDate() < 10 ? '0'+currentDate.getDate() : currentDate.getDate()

		const today = currentDate.getFullYear() + '-' + formatMonth + '-' + formatDate

		try {
			let apiResp = {};
			if (reportType === 1) {
				apiResp = await generateArPerClient(userID, getParamCustomer, formValues.dateRange);
			}
			else if (reportType === 2) {
				apiResp = await generateArSummary(userID, today);
			}
			else if (reportType === 3) {
				apiResp = await generateBirSalesRep(userID, formValues.dateRange);
			}
			else if (reportType === 4) {
				apiResp = await generateColRepPerClient(userID, getParamCustomer, formValues.dateRange);
			}
			else if (reportType === 5) {
				// apiResp = await generateColRepPerMonth(userID, getParamMonYear);
			}
			else if (reportType === 6) {
				// const fromTo = getParamWeek.split('~');
				// apiResp = await generateColRepPerWeek(userID, fromTo[0], fromTo[1]);
			}
			else if (reportType === 7) {
				apiResp = await generateColRepSummary(userID, formValues.dateRange);
			}
			else if (reportType === 8) {
				apiResp = await generateRepAgentPerMonth(userID, getParamAgent, formValues.dateRange);
			}
			else if (reportType === 9) {//OR SERIES ACD 20221213
				apiResp = await generateOrSeries(userID, formValues.dateRange);
			}
			else if (reportType === 10) { //PR Series no news yet
				// const link = `reports/colRepPerWeek?userID=${userID}&postMonthYear=${getParamMonYear}`;
				// generateReport(link);
			}
			else if (reportType === 11) {
				apiResp = await generateSalesRepPerClientMonth(userID, getParamCustomer, formValues.dateRange);
			}
			else if (reportType === 12) {
				apiResp = await generateSalesRepPerAgentMonth(userID, getParamCustomer, getParamAgent, formValues.dateRange);
			}
			else if (reportType === 13) {
				// const link = `reports/salesRepPerMonthBr?userID=${userID}&postMonthYear=${getParamMonYear}`;
				// generateReport(link);
				apiResp = await generateSalesRepPerMonthBr(userID, getParamCustomer, formValues.dateRange);
			}
			else if (reportType === 14) {
				apiResp = await generateSoa(userID, getParamCustomer, getParamAgent, formValues.dateRange);
			}
			else if (reportType === 18) {
				apiResp = await generateArAgingPerClient(userID, getParamCustomer, formValues.dateRange);
			}
			else if (reportType === 19) {
				apiResp = await generateColRepPerPayDate(userID, formValues.dateRange);
			}
			else if (reportType === 20){
				// apiResp = await generateColRepPerPayDate(userID, formValues.dateRange);
				apiResp = await generateAr(userID, formValues.dateRange);
			}
			else if (reportType === 21){
				apiResp = await generateArAging(userID, formValues.dateRange);
			}
			else if (reportType === 22) {
				apiResp = await generateColReport(userID, formValues.dateRange);
			}
			else if (reportType === 23) {
				apiResp = await generateSalesReport(userID, getParamCustomer, formValues.dateRange);
			}
			else if (reportType === 25) {
				apiResp = await generateDrSeries(userID, formValues.dateRange);
			}
			else if (reportType === 26) {
				apiResp = await generateUnbilledDr(userID, formValues.dateRange);
			}
			else if (reportType === 27) {
				apiResp = await generateDrClientDelivery(userID, getParamCustomer, formValues.dateRange);
			}
			else{
				console.log('Report Type ID Not Existing');
			}

			// console.log('apiResp => ' , apiResp);

			switch(apiResp.messageType) {
			case ('MESSAGE_SUCCESS'):
				Message.success({ message: apiResp.messageDisplay });

				const genReports = await fetchGeneratedReports(reportType); //to refresh search results
				setGeneratedReports(genReports);

				// Set the latest generated document ID to focus on it
				if (apiResp.data && apiResp.data.generated_document_id) {
					setLatestGeneratedId(apiResp.data.generated_document_id);
				} else if (genReports && genReports.length > 0) {
					// If no ID in response, use the first item (most recent)
					setLatestGeneratedId(genReports[0].generated_document_id);
				}

				break;
			case ('MESSAGE_ERROR'):
				Message.error({ message: apiResp.messageDisplay });
				break;
			default :
			}
			
		} catch (error) {
			console.log('error', error);
		}
	}

	function handleParameters(value) {
		setParamGenerate(value);
	}

	function paramCustomer(value) {
		setParamCustomer(value);
		// setDisable(false);
	}

	function paramAgent(value) {
		setParamAgent(value);
		// setDisable(false);
	}

	function paramMonYear(value) {
		setParamMonYear(value);
		// if(value){
		// 	setDisable(false);
		// }else{
		// 	setDisable(true);
		// }
	}

	function paramYear(value) {
		setParamYear(value);
		// if(value){
		// 	setDisable(false);
		// }else{
		// 	setDisable(true);
		// }
	}

	function paramDate(value) {
		setParamDate(value);
		// if(value){
		// 	setDisable(false);
		// }else{
		// 	setDisable(true);
		// }
	}

	function paramWeek(value) {
		setParamWeek(value);
		// if(value){
		// 	setDisable(false);
		// }else{
		// 	setDisable(true);
		// }
	}

	function paramAsOfDate(value){
		setParamAsOfDate(value);
		// if(value){
		// 	setDisable(false);
		// }else{
		// 	setDisable(true);
		// }
	}

	function paramDateRange(value){
		// if(value){
		// 	setDisable(false);
		// }else{
		// 	setDisable(true);
		// }
	}

	function clearSearch() {
		// @ts-ignore
		const { setFieldsValue } = formRef.current;
		const resetParameters = {
			// report: undefined,
			dateRange: undefined,
		}

		switch(reportType){
			case 1:
				resetParameters.customer = undefined;
				break;
			case 2:
				resetParameters.asOfDate = undefined;
				break;
			case 3:
				resetParameters.monthYear = undefined;
				setParamMonYear(null);
				break;
			case 4:
				resetParameters.customer = undefined;
				resetParameters.year = undefined;
				break;
			case 5:
				resetParameters.monthYear = undefined;
				break;
			case 6:
				resetParameters.week = undefined;
				break;
			case 7:
				resetParameters.year = undefined;
				break;
			case 8:
				resetParameters.agent = undefined;
				resetParameters.monthYear = undefined;
				break;
			case 9:
				resetParameters.orNo = undefined;
				break;
			case 10:
				// PR Series monitoring - no info yet	
				resetParameters.year = undefined;
				break;
			case 11:
				resetParameters.customer = undefined;
				resetParameters.monthYear = undefined;
				break;
			case 12:
				resetParameters.customer = undefined;
				resetParameters.agent = undefined;
				resetParameters.date = undefined;
				break;
			case 13:
				resetParameters.monthYear = undefined;
				break;
			case 14:
				resetParameters.customer = undefined;
				resetParameters.agent = undefined;
				resetParameters.date = undefined;
				break;
			case 18:
				resetParameters.agent = undefined;
				resetParameters.date = undefined;
				break;
			default:
				
		}
		setFieldsValue(resetParameters);
		// setDisable(true);
	}

	async function handleReport(e) {
		if(e !== undefined || e !== ''){
			setDisable(false);
		}

		console.log('report e => ' , e);

		setReportType(e);

		const params = await fetchParams(e);
		setParams(params);

		const genReports = await fetchGeneratedReports(e);
		setGeneratedReports(genReports);

		form.resetFields();
	}

	useEffect(()=> {
		const { setFieldsValue } = formRef.current;
		const resetParameters = {
			// report: undefined,
			dateRange: undefined,
			customer: undefined,
			asOfDate: undefined,
			monthYear: undefined,
			year: undefined,
			week: undefined,
			agent: undefined,
			date: undefined
		}

		setFieldsValue(resetParameters);
	}, [reportType]);

	return (
		<div>
			<Form layout="vertical" onFinish={handleSubmit} ref={formRef}>
				<Row gutter={[8, 1]} align="bottom">
					<Col span={8} className="gutter-row">
						<Form.Item label="REPORT" name="report" rules={[{ required: true, message: 'Required Field' }]}>
							<Select
								placeholder="REPORT"
								showSearch
								onSelect={handleReport}
								filterOption={(input, option) =>
									option.children.toLowerCase().includes(input.toLowerCase())
								}
								// onChange={handleOnChangeReport}
							>
								{reportsOptions}
							</Select>
						</Form.Item>
					</Col>
					<Col span={8}></Col>
					<Col span={8} style={{ textAlign: 'right' }}>
						<Button
							className="login-form-button inv-button"
							type="primary"
							htmlType="submit"
							disabled={disable}
						>
							GENERATE
						</Button>
						<Button className="form-button inv-button-right" onClick={clearSearch}>
							CLEAR
						</Button>
					</Col>
				</Row>
				<SearchLov
					showReport={params}
					customerLabel={customerLabel === undefined ? 'NA' : customerLabel}
					yearLabel={yearLabel === undefined ? 'NA' : yearLabel}
					monthLabel={monthLabel === undefined ? 'NA' : monthLabel}
					dateLabel={dateLabel === undefined ? 'NA' : dateLabel}
					agentLabel={agentLabel === undefined ? 'NA' : agentLabel}
					weekLabel={weekLabel === undefined ? 'NA' : weekLabel}
					asOfDateLabel={asOfDateLabel === undefined ? 'NA' : asOfDateLabel}
					reportType={reportType}
					// setDisable={disable}
					handleParameters={handleParameters}
					paramCustomer={paramCustomer}
					paramAgent={paramAgent}
					paramMonYear={paramMonYear}
					paramYear={paramYear}
					paramDate={paramDate}
					paramWeek={paramWeek}
					paramAsOfDate={paramAsOfDate}
					paramDateRange={paramDateRange}
				/>
			</Form>
			<SearchReportTable data={generatedReports} latestGeneratedId={latestGeneratedId} />
		</div>
	);
}

export default SearchReportForm;